"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6746],{

/***/ 36112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowContainedIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: dimension || 24,
        height: dimension || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                y: "24",
                width: "24",
                height: "24",
                rx: "8",
                transform: "rotate(-90 0 24)",
                fill: "#DFEBE5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 14.0001C17 13.8578 16.9456 13.7156 16.8372 13.6073L12.3928 9.16291C12.1756 8.94569 11.8245 8.94569 11.6073 9.16291L7.16291 13.6073C6.9457 13.8245 6.9457 14.1756 7.16291 14.3928C7.38013 14.6101 7.73124 14.6101 7.94846 14.3928L12.0001 10.3412L16.0517 14.3928C16.2689 14.6101 16.62 14.6101 16.8372 14.3928C16.9456 14.2845 17 14.1423 17 14.0001Z",
                fill: "#6DA588"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowContainedIcon);


/***/ }),

/***/ 88721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var BigAddIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: dimension || 44,
        height: dimension || 44,
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.25 37.75C16.25 40.9136 18.8364 43.5 22 43.5C25.1636 43.5 27.75 40.9136 27.75 37.75V27.75H37.75C40.9136 27.75 43.5 25.1636 43.5 22C43.5 18.8364 40.9136 16.25 37.75 16.25H27.75V6.25C27.75 3.08636 25.1636 0.5 22 0.5C18.8364 0.5 16.25 3.08636 16.25 6.25V16.25H6.25C3.08636 16.25 0.5 18.8364 0.5 22C0.5 25.1636 3.08636 27.75 6.25 27.75H16.25V37.75Z",
            fill: color || "#CBD1D9",
            stroke: "white"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BigAddIcon);


/***/ }),

/***/ 43172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var NoPhotosIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, dimension = _param.dimension, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "color",
        "dimension"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: dimension || 48,
        height: dimension || 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "path-1-inside-1_3947_24243",
                fill: "white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14 21.4627C15.1945 20.7698 16 19.4767 16 18V16H18C20.2046 16 22 14.2046 22 12C22 11.2721 21.8043 10.5888 21.4627 10H29.155C29.6952 10 30.2125 10.2185 30.589 10.6058L36 16.1714L41.3936 21.4109C41.7813 21.7875 42 22.305 42 22.8455V42C42 43.1046 41.1046 44 40 44H16C14.8954 44 14 43.1046 14 42V21.4627Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 21.4627C15.1945 20.7698 16 19.4767 16 18V16H18C20.2046 16 22 14.2046 22 12C22 11.2721 21.8043 10.5888 21.4627 10H29.155C29.6952 10 30.2125 10.2185 30.589 10.6058L36 16.1714L41.3936 21.4109C41.7813 21.7875 42 22.305 42 22.8455V42C42 43.1046 41.1046 44 40 44H16C14.8954 44 14 43.1046 14 42V21.4627Z",
                fill: color || "#CBD1D9"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14 21.4627L12.9964 19.7327L12 20.3108V21.4627H14ZM16 16V14H14V16H16ZM21.4627 10V8H17.9903L19.7327 11.0036L21.4627 10ZM30.589 10.6058L32.023 9.21169V9.21169L30.589 10.6058ZM36 16.1714L34.566 17.5656L34.5859 17.5861L34.6064 17.606L36 16.1714ZM41.3936 21.4109L40 22.8455L40 22.8455L41.3936 21.4109ZM15.0036 23.1927C16.7869 22.1582 18 20.2215 18 18H14C14 18.7319 13.6021 19.3814 12.9964 19.7327L15.0036 23.1927ZM18 18V16H14V18H18ZM16 18H18V14H16V18ZM18 18C21.3091 18 24 15.3091 24 12H20C20 13.1 19.1 14 18 14V18ZM24 12C24 10.9091 23.7057 9.88085 23.1927 8.99641L19.7327 11.0036C19.9028 11.2967 20 11.6351 20 12H24ZM29.155 8H21.4627V12H29.155V8ZM32.023 9.21169C31.2699 8.43704 30.2354 8 29.155 8V12L29.155 12L32.023 9.21169ZM37.434 14.7773L32.023 9.21169L29.155 12L34.566 17.5656L37.434 14.7773ZM42.7871 19.9763L37.3936 14.7369L34.6064 17.606L40 22.8455L42.7871 19.9763ZM44 22.8455C44 21.7645 43.5625 20.7295 42.7871 19.9763L40 22.8455L40 22.8455H44ZM44 42V22.8455H40V42H44ZM40 46C42.2091 46 44 44.2091 44 42H40V46ZM16 46H40V42H16V46ZM12 42C12 44.2091 13.7909 46 16 46V42H16H12ZM12 21.4627V42H16V21.4627H12Z",
                fill: color || "#CBD1D9",
                mask: "url(#path-1-inside-1_3947_24243)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.5 18C9.5 19.3761 10.6239 20.5 12 20.5C13.3761 20.5 14.5 19.3761 14.5 18V14.5H18C19.3761 14.5 20.5 13.3761 20.5 12C20.5 10.6239 19.3761 9.5 18 9.5H14.5V6C14.5 4.62386 13.3761 3.5 12 3.5C10.6239 3.5 9.5 4.62386 9.5 6V9.5H6C4.62386 9.5 3.5 10.6239 3.5 12C3.5 13.3761 4.62386 14.5 6 14.5H9.5V18Z",
                fill: color || "#CBD1D9",
                stroke: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NoPhotosIcon);


/***/ }),

/***/ 99020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99226);
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8573);
/* harmony import */ var _helper_gigStates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50481);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97734);






var GigStateTag = function(param) {
    var gigStateValue = param.gigStateValue, bidValue = param.bidValue;
    var ref = (0,_helper_gigStates__WEBPACK_IMPORTED_MODULE_2__/* .getStateData */ .O)(gigStateValue), color = ref.color, text = ref.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            padding: 1,
            borderRadius: "0.5rem",
            backgroundColor: color,
            width: "fit-content"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            variant: "small5",
            sx: {
                color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.brand1[50] */ .r.brand1[50]
            },
            children: "".concat(text).concat(gigStateValue === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OPEN_BID */ .Z.OPEN_BID && bidValue ? ": $".concat(bidValue) : "")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GigStateTag);


/***/ }),

/***/ 8170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_InsertPhoto__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50644);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98396);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(65450);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(89007);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(18377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91444);
/* harmony import */ var _assets_Icons_BigAddIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88721);
/* harmony import */ var _assets_Icons_NoPhotosIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43172);
/* harmony import */ var _constants_General__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63086);
/* harmony import */ var _firebase_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32012);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24849);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57753);
/* harmony import */ var _NoDataUI__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89243);
/* harmony import */ var _profile_PhotoDetailsModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76966);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97734);



















var ImagesGrid = function(param) {
    var _itemData = param.itemData, itemData = _itemData === void 0 ? [] : _itemData, _readOnly = param.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, handleUpload = param.handleUpload, onImageRemove = param.onImageRemove, sx = param.sx, _subTitle = param.subTitle, subTitle = _subTitle === void 0 ? "Please upload your first Photos and share to the other user" : _subTitle, _maxImage = param.maxImage, maxImage = _maxImage === void 0 ? _constants_General__WEBPACK_IMPORTED_MODULE_12__/* .NUMBER_OF_IMAGE_LIMIT */ .QL : _maxImage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(NaN), selectedImageIndex = ref1[0], setSelectedImageIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(itemData), imageData = ref2[0], setImageData = ref2[1];
    var userUid = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.user.user.uid;
    });
    var userData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.user.user;
    });
    var isMdSize = (0,_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("(min-width:900px)");
    var numberOfImages = imageData.length;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setImageData(itemData);
    }, [
        itemData.length
    ]);
    var handlePhotoClick = function(index) {
        setSelectedImageIndex(index);
        setOpenModal(true);
    };
    var handleImageRemove = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            var imageRef;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageRef = imageData[selectedImageIndex].imageRef;
                        if (!imageRef) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,_firebase_user__WEBPACK_IMPORTED_MODULE_6__/* .imageRemoveFromDB */ .H0)(userData, imageRef)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        onImageRemove && onImageRemove(selectedImageIndex);
                        setOpenModal(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleImageRemove() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(event) {
            var files, remainingSpace, addedImagesUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        files = Array.from(event.target.files);
                        remainingSpace = maxImage - imageData.length;
                        if (files.length >= remainingSpace) {
                            files = files.slice(0, remainingSpace);
                            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error("You can not add more than ".concat(maxImage, " images."));
                        }
                        if (!(files.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all(Array.from(files).map(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(image) {
                                    var url, _tmp;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = event.target && userUid && handleUpload;
                                                if (!_tmp) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handleUpload(image)
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                url = _tmp;
                                                return [
                                                    2,
                                                    url
                                                ];
                                        }
                                    });
                                });
                                return function(image) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        addedImagesUrl = _state.sent();
                        setImageData(function(latestData) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(addedImagesUrl).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(latestData));
                        });
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        sx: sx,
        children: [
            !(imageData.length > 0) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                sx: {
                    width: "100%",
                    display: "grid",
                    placeItems: "center",
                    mt: "36px"
                },
                children: readOnly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NoDataUI__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    Icon: _mui_icons_material_InsertPhoto__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
                    displayMessage: "No images",
                    sx: {
                        minHeight: "200px"
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    sx: {
                        width: "233px",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_NoPhotosIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                mt: "20px"
                            },
                            variant: "h3",
                            children: "No Photos"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                textAlign: "center",
                                mt: 1
                            },
                            variant: "body2",
                            children: subTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            sx: {
                                mt: 5
                            },
                            "aria-label": "upload picture",
                            component: "label",
                            variant: "text",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    hidden: true,
                                    accept: "image/*",
                                    type: "file",
                                    onChange: handleChange,
                                    multiple: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "title2",
                                    sx: {
                                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_7__/* .theme.brand1[500] */ .r.brand1[500],
                                        textTransform: "none"
                                    },
                                    children: "Upload Now"
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                sx: {
                    "& li": {
                        borderRadius: "6px",
                        overflow: "hidden"
                    }
                },
                gap: isMdSize ? 16 : 8,
                cols: isMdSize ? 5 : 3,
                children: [
                    !readOnly && numberOfImages < maxImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        sx: {
                            height: "100%",
                            width: "100%",
                            backgroundColor: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_7__/* .theme.whiteBg.WBG3 */ .r.whiteBg.WBG3
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            color: "primary",
                            "aria-label": "upload picture",
                            component: "label",
                            sx: {
                                height: "100%",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    hidden: true,
                                    accept: "image/*",
                                    type: "file",
                                    onChange: handleChange,
                                    multiple: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_BigAddIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    height: 50,
                                    width: 50
                                })
                            ]
                        })
                    }),
                    imageData.map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            sx: {
                                aspectRatio: "1/1",
                                cursor: "pointer",
                                "& img": {
                                    height: "100% !important"
                                }
                            },
                            onClick: function() {
                                handlePhotoClick(index);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                src: item === null || item === void 0 ? void 0 : item.url,
                                style: {
                                    flexGrow: 1,
                                    objectFit: "cover"
                                }
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_profile_PhotoDetailsModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                readOnly: readOnly,
                handleNextImage: function() {
                    selectedImageIndex < imageData.length - 1 && setSelectedImageIndex(function(latestIndex) {
                        return latestIndex + 1;
                    });
                },
                handlePreviousImage: function() {
                    selectedImageIndex > 0 && setSelectedImageIndex(function(latestIndex) {
                        return latestIndex - 1;
                    });
                },
                handleClose: function() {
                    setOpenModal(false);
                },
                imgUrl: imageData[selectedImageIndex] && imageData[selectedImageIndex].url,
                handleImageRemove: handleImageRemove,
                open: openModal
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImagesGrid);


/***/ }),

/***/ 89243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97734);





var NoDataUI = function(param) {
    var Icon = param.Icon, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 50 : _iconSize, displayMessage = param.displayMessage, sx = param.sx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "400px",
            flexDirection: "column",
            gap: 2,
            boxSizing: "border-box"
        }, sx),
        children: [
            Icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4,
                    fontSize: iconSize
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "title4",
                sx: {
                    color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.whiteBg.WBG4 */ .r.whiteBg.WBG4
                },
                children: displayMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoDataUI);


/***/ }),

/***/ 91698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82280);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38895);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22797);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _assets_Icons_ArrowContainedIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36112);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24849);
/* harmony import */ var _redux_createProfilePageSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59462);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97734);











var ProfileAccordionContainer = function(_param) {
    var children = _param.children, name = _param.name, value = _param.value, sx = _param.sx, defaultExpanded = _param.defaultExpanded, _optimized = _param.optimized, optimized = _optimized === void 0 ? false : _optimized, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "children",
        "name",
        "value",
        "sx",
        "defaultExpanded",
        "optimized"
    ]);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultExpanded), localExpandState = ref[0], setLocalExpandState = ref[1];
    var handleAccordionChange = function(event, expanded) {
        if (value === undefined) {
            setLocalExpandState(expanded);
        } else {
            dispatch((0,_redux_createProfilePageSlice__WEBPACK_IMPORTED_MODULE_5__/* .setExpandedAccordion */ .b0)(expanded ? value : null));
        }
    };
    var expandedAccordion = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.profilePage.expandedAccordion;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        disableGutters: true,
        sx: {
            boxShadow: "none",
            py: 1,
            "&::before": {
                display: "none"
            }
        },
        onChange: handleAccordionChange,
        expanded: value !== undefined ? expandedAccordion === value : localExpandState
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_Icons_ArrowContainedIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                sx: {
                    px: "0px",
                    "& .Mui-expanded p": {
                        color: "".concat(_mui_customs_Theme__WEBPACK_IMPORTED_MODULE_4__/* .theme.brand1[500] */ .r.brand1[500], " !important")
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "title2",
                    sx: {
                        color: _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_4__/* .theme.grey2[500] */ .r.grey2[500]
                    },
                    children: name
                })
            }),
            optimized ? (value !== undefined ? expandedAccordion === value : localExpandState) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    px: "0px"
                }, sx),
                children: children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    px: "0px"
                }, sx),
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileAccordionContainer);


/***/ }),

/***/ 18621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yw": function() { return /* binding */ getGigStartDate; },
/* harmony export */   "fc": function() { return /* binding */ convertDateFormat; },
/* harmony export */   "q1": function() { return /* binding */ getGigEndDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__);



dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default()));
var convertDateFormat = function(date) {
    var addTime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (addTime) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).utc().format("MM/DD/YYYY, hh:mm A");
    }
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).utc().format("MM/DD/YYYY");
};
var getGigStartDate = function(gig) {
    var ref;
    var startDate;
    if (gig === null || gig === void 0 ? void 0 : (ref = gig.multiDate) === null || ref === void 0 ? void 0 : ref.startDate) {
        var ref1;
        startDate = gig === null || gig === void 0 ? void 0 : (ref1 = gig.multiDate) === null || ref1 === void 0 ? void 0 : ref1.startDate;
    } else {
        startDate = gig === null || gig === void 0 ? void 0 : gig.date;
    }
    return startDate;
};
var getGigEndDate = function(gig) {
    var ref;
    var endDate;
    if (gig === null || gig === void 0 ? void 0 : (ref = gig.multiDate) === null || ref === void 0 ? void 0 : ref.endDate) {
        var ref1;
        endDate = gig === null || gig === void 0 ? void 0 : (ref1 = gig.multiDate) === null || ref1 === void 0 ? void 0 : ref1.endDate;
    } else {
        endDate = gig === null || gig === void 0 ? void 0 : gig.date;
    }
    return endDate;
};



/***/ }),

/***/ 50481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getStateData; }
/* harmony export */ });
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8573);
/* harmony import */ var _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24849);


function getStateData(state, newText) {
    var color;
    var text;
    switch(state){
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DRAFT */ .Z.DRAFT:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "Draft";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].OPEN_BID */ .Z.OPEN_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.purple[300] */ .r.purple[300];
            text = newText || "Open Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].NEW_GIG */ .Z.NEW_GIG:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand2[500] */ .r.brand2[500];
            text = newText || "New Gig";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ACCEPTED_BOOKED */ .Z.ACCEPTED_BOOKED:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[500] */ .r.brand1[500];
            text = newText || "Accepted Booked";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[500] */ .r.brand1[500];
            text = newText || "Accepted Booked";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INVOICE_CHANGE */ .Z.INVOICE_CHANGE:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.yellow[500] */ .r.yellow[500];
            text = newText || "Invoice Change";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand1[700] */ .r.brand1[700];
            text = newText || "Finished & Paid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CANCELED_GIG */ .Z.CANCELED_GIG:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.red[300] */ .r.red[300];
            text = newText || "Canceled Gig";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CANCELED_BID */ .Z.CANCELED_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.red[300] */ .r.red[300];
            text = newText || "Canceled Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DECLINED_BID */ .Z.DECLINED_BID:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.brand2[750] */ .r.brand2[750];
            text = newText || "Declined Bid";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PENDING */ .Z.PENDING:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.purple[200] */ .r.purple[200];
            text = newText || "Pending";
            break;
        case _constants_ProposalState__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LIKED */ .Z.LIKED:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "Liked";
            break;
        default:
            color = _mui_customs_Theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.grey2[500] */ .r.grey2[500];
            text = newText || "None";
            break;
    }
    return {
        color: color,
        text: text
    };
}



/***/ })

}]);